import React from "react";
import Alert from "../alert/alert";

const PageAlert = props => <Alert {...props} />;

PageAlert.displayName = "OrionPageAlert";

export default PageAlert;
